import { gql } from '@apollo/client';

export const getQueryPayments = customer => `
{
    payments (customer: "${customer}"){
        _id name refPrice type active guid ref paymentIcon createdAd updatedAt authorizesCashback customer { _id name }
    }
}
`;

export const GET_CUSTOM_PAYMENTS = gql`
  query getCustomPayments(
    $customer: ID!
    $authorizesCashback: Boolean
    $active: Boolean
  ) {
    customPayments(
      customer: $customer
      authorizesCashback: $authorizesCashback
      active: $active
    ) {
      _id
      name
      type
      active
      guid
      ref
      refPrice
      paymentIcon
      createdAd
      updatedAt
      authorizesCashback
      customer {
        _id
        name
      }
    }
  }
`;
